import getComments from '@/ajax/shop/article/get-comments';
import sendComment from '@/ajax/shop/article/send-comment';

export default {
  getComments,
  sendComment
};
